import React from 'react';
import { Button as MUIButton } from '@mui/material';

export function Button({ children, ...rest }) {
    return (
        <MUIButton variant={'outlined'} color={'primary'} {...rest}>
            {children}
        </MUIButton>
    );
};

